import React from 'react';
import { WidgetType } from './WidgetType';

interface IWidgetContext {
  type?: WidgetType;
}

export const WidgetContext = React.createContext<IWidgetContext>({});
